import config from '../config'
import {
  GET_TARGETMORAL_COUNT, GET_TARGETMORAL_COUNT_FAILURE, GET_TARGETMORAL_COUNT_SUCCESS,
  GET_NOANSWERMORAL_COUNT, GET_NOANSWERMORAL_COUNT_FAILURE, GET_NOANSWERMORAL_COUNT_SUCCESS,
  GET_MESSAGEMANAGER_COUNT, GET_MESSAGEMANAGER_COUNT_FAILURE, GET_MESSAGEMANAGER_COUNT_SUCCESS,
  GET_MESSAGEOFFICER_COUNT, GET_MESSAGEOFFICER_COUNT_FAILURE, GET_MESSAGEOFFICER_COUNT_SUCCESS,
  GET_MESSAGEHARASSMENT_COUNT, GET_MESSAGEHARASSMENT_COUNT_FAILURE, GET_MESSAGEHARASSMENT_COUNT_SUCCESS,
  GET_UNAPPROVED_PROPOSE_COUNT, GET_UNAPPROVED_PROPOSE_COUNT_FAILURE, GET_UNAPPROVED_PROPOSE_COUNT_SUCCESS,
  EXIST_REQUEST_HOLIDAY_NOTICE, EXIST_REQUEST_HOLIDAY_NOTICE_FAILURE, EXIST_REQUEST_HOLIDAY_NOTICE_SUCCESS,
  GET_SHIFT_NOTICE_COUNT, GET_SHIFT_NOTICE_COUNT_FAILURE, GET_SHIFT_NOTICE_COUNT_SUCCESS,
  GET_MAGAZINE, GET_MAGAZINE_SUCCESS, GET_MAGAZINE_FAILURE,
  GO_KISOKU, GO_YESWECAN,
  EXIST_WILL_MUST_NOTICE, EXIST_WILL_MUST_NOTICE_SUCCESS, EXIST_WILL_MUST_NOTICE_FAILURE,
  EXIST_PROPOSE_NOTICE, EXIST_PROPOSE_NOTICE_SUCCESS, EXIST_PROPOSE_NOTICE_FAILURE,
  GET_NOANSWER_SERVICE_QUESTION_COUNT, GET_NOANSWER_SERVICE_QUESTION_COUNT_SUCCESS, GET_NOANSWER_SERVICE_QUESTION_COUNT_FAILURE,
  GET_TARGET_SERVICE_QUESTION_COUNT, GET_TARGET_SERVICE_QUESTION_COUNT_SUCCESS, GET_TARGET_SERVICE_QUESTION_COUNT_FAILURE,
  EXIST_SAFETY_CONFIRMATION, EXIST_SAFETY_CONFIRMATION_SUCCESS, EXIST_SAFETY_CONFIRMATION_FAILURE
} from './mutation-types'

export default {
  state: {
    targetmoralCount: 0,
    noanswermoralCount: 0,
    messagemanagerCount: 0,
    messageofficerCount: 0,
    messageharassmentCount: 0,
    messagemanagerAllCount: 0,
    messageofficerAllCount: 0,
    messageharassmentAllCount: 0,
    upapprovedProposeCount: 0,
    targetmoralEnddate: null,
    existRequestHolidayNotice: 0,
    shiftNoticeCount: 0,
    shiftNotices: null,
    magazines: null,
    magazineMinYear: null,
    config: config,
    existWillMustNotice: 0,
    existProposeAdoptedNotice: 0,
    existProposeApprovedNotice: 0,
    targetServiceQuestionCount: 0,
    ownServiceQuestion: null,
    noanswerServiceQuestionCount: 0,
    isExistSafetyConfirmation: false,
    isTrainingSafetyConfirmation: false,
    isSentSafetyConfirmation: false,
    isConfirmedSafetyConfirmation: false
  },
  getters: {
    targetmoralCount: state => {
      return state.targetmoralCount
    },
    targetmoralEnddate: state => {
      return state.targetmoralEnddate
    },
    noanswermoralCount: state => {
      return state.noanswermoralCount
    },
    messagemanagerCount: state => {
      return state.messagemanagerCount
    },
    messageofficerCount: state => {
      return state.messageofficerCount
    },
    messageharassmentCount: state => {
      return state.messageharassmentCount
    },
    messagemanagerAllCount: state => {
      return state.messagemanagerAllCount
    },
    messageofficerAllCount: state => {
      return state.messageofficerAllCount
    },
    messageharassmentAllCount: state => {
      return state.messageharassmentAllCount
    },
    unApprovedProposeCount: state => {
      return state.upapprovedProposeCount
    },
    existRequestHolidayNotice: state => {
      return state.existRequestHolidayNotice
    },
    existWillMustNotice: state => {
      return state.existWillMustNotice
    },
    shiftNoticeCount: state => {
      return state.shiftNoticeCount
    },
    shiftNotices: state => {
      return state.shiftNotices
    },
    magazines: state => {
      return state.magazines
    },
    magazineMinYear: state => {
      return state.magazineMinYear
    },
    existProposeAdoptedNotice: state => {
      return state.existProposeAdoptedNotice
    },
    existProposeApprovedNotice: state => {
      return state.existProposeApprovedNotice
    },
    targetServiceQuestionCount: state => {
      return state.targetServiceQuestionCount
    },
    ownServiceQuestion: state => {
      return state.ownServiceQuestion
    },
    noanswerServiceQuestionCount: state => {
      return state.noanswerServiceQuestionCount
    },
    isExistSafetyConfirmation: state => {
      return state.isExistSafetyConfirmation
    },
    isTrainingSafetyConfirmation: state => {
      return state.isTrainingSafetyConfirmation
    },
    isSentSafetyConfirmation: state => {
      return state.isSentSafetyConfirmation
    },
    isConfirmedSafetyConfirmation: state => {
      return state.isConfirmedSafetyConfirmation
    }
  },
  actions: {
    [GET_TARGETMORAL_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_targetmoral_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_TARGETMORAL_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_TARGETMORAL_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_NOANSWERMORAL_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_noanswermoral_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_NOANSWERMORAL_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_NOANSWERMORAL_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEMANAGER_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_messagemanager_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_MESSAGEMANAGER_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_MESSAGEMANAGER_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEOFFICER_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_messageofficer_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_MESSAGEOFFICER_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_MESSAGEOFFICER_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEHARASSMENT_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_messageharassment_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_MESSAGEHARASSMENT_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_MESSAGEHARASSMENT_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_UNAPPROVED_PROPOSE_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_unapproved_propose_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_UNAPPROVED_PROPOSE_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_UNAPPROVED_PROPOSE_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [EXIST_REQUEST_HOLIDAY_NOTICE] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/exist_request_holiday_notice'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(EXIST_REQUEST_HOLIDAY_NOTICE_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(EXIST_REQUEST_HOLIDAY_NOTICE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_SHIFT_NOTICE_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_shift_notice_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_SHIFT_NOTICE_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_SHIFT_NOTICE_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MAGAZINE] ({dispatch, state, commit}, params) {
      var data = params.data
      var url = '/asovi/magazines'
      var callback = null
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_MAGAZINE_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GET_MAGAZINE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GO_KISOKU] ({dispatch, state, commit}, params) {
      commit(GO_KISOKU)
    },
    [GO_YESWECAN] ({dispatch, state, commit}, params) {
      commit(GO_YESWECAN)
    },
    [EXIST_WILL_MUST_NOTICE] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/exist_will_must_notice'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(EXIST_WILL_MUST_NOTICE_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(EXIST_WILL_MUST_NOTICE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [EXIST_PROPOSE_NOTICE] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/exist_propose_notice'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(EXIST_PROPOSE_NOTICE_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(EXIST_PROPOSE_NOTICE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [EXIST_SAFETY_CONFIRMATION] ({dispatch, state, commit}) {
      var url = '/asovi/home/exist_safety_confirmation'
      var callback = null
      dispatch('apiGet', {url: url, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(EXIST_SAFETY_CONFIRMATION_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(EXIST_SAFETY_CONFIRMATION_SUCCESS, {data: res.data})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_TARGET_SERVICE_QUESTION_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_target_service_question_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_TARGET_SERVICE_QUESTION_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_TARGET_SERVICE_QUESTION_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_NOANSWER_SERVICE_QUESTION_COUNT] ({dispatch, state, commit}, params) {
      var url = '/asovi/home/get_noanswer_service_question_count'
      var data = params.data
      var callback = null
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(GET_NOANSWER_SERVICE_QUESTION_COUNT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(GET_NOANSWER_SERVICE_QUESTION_COUNT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [GET_TARGETMORAL_COUNT_FAILURE] (state, data) {
      console.log('GET_TARGETMORAL_COUNT_FAILURE')
    },
    [GET_TARGETMORAL_COUNT_SUCCESS] (state, data) {
      console.log('GET_TARGETMORAL_COUNT_SUCCESS')
      state.targetmoralCount = data.count
      if (data.count > 0) {
        state.targetmoralEnddate = data.moral_result[0]['moral_end_date']
      }
      if (data.callback) {
        data.callback()
      }
    },
    [GET_NOANSWERMORAL_COUNT_FAILURE] (state, data) {
      console.log('GET_NOANSWERMORAL_COUNT_FAILURE')
    },
    [GET_NOANSWERMORAL_COUNT_SUCCESS] (state, data) {
      console.log('GET_NOANSWERMORAL_COUNT_SUCCESS')
      state.noanswermoralCount = data.count
      if (data.callback) {
        data.callback()
      }
    },
    [GET_MESSAGEMANAGER_COUNT_FAILURE] (state, data) {
      console.log('GET_MESSAGEMANAGER_COUNT_FAILURE')
    },
    [GET_MESSAGEMANAGER_COUNT_SUCCESS] (state, data) {
      console.log('GET_MESSAGEMANAGER_COUNT_SUCCESS')
      state.messagemanagerCount = data.count
      state.messagemanagerAllCount = data.all_count
      if (data.callback) {
        data.callback()
      }
    },
    [GET_MESSAGEOFFICER_COUNT_FAILURE] (state, data) {
      console.log('GET_MESSAGEOFFICER_COUNT_FAILURE')
    },
    [GET_MESSAGEOFFICER_COUNT_SUCCESS] (state, data) {
      console.log('GET_MESSAGEOFFICER_COUNT_SUCCESS')
      state.messageofficerCount = data.count
      state.messageofficerAllCount = data.all_count
      if (data.callback) {
        data.callback()
      }
    },
    [GET_MESSAGEHARASSMENT_COUNT_FAILURE] (state, data) {
      console.log('GET_MESSAGEHARASSMENT_COUNT_FAILURE')
    },
    [GET_MESSAGEHARASSMENT_COUNT_SUCCESS] (state, data) {
      console.log('GET_MESSAGEHARASSMENT_COUNT_SUCCESS')
      state.messageharassmentCount = data.count
      state.messageharassmentAllCount = data.all_count
      if (data.callback) {
        data.callback()
      }
    },
    [GET_UNAPPROVED_PROPOSE_COUNT_FAILURE] (state, data) {
      console.log('GET_UNAPPROVED_PROPOSE_COUNT_FAILURE')
    },
    [GET_UNAPPROVED_PROPOSE_COUNT_SUCCESS] (state, data) {
      console.log('GET_UNAPPROVED_PROPOSE_COUNT_SUCCESS')
      state.upapprovedProposeCount = data.count
      if (data.callback) {
        data.callback()
      }
    },
    [EXIST_REQUEST_HOLIDAY_NOTICE_FAILURE] (state, data) {
      console.log('EXIST_REQUEST_HOLIDAY_NOTICE_FAILURE')
    },
    [EXIST_REQUEST_HOLIDAY_NOTICE_SUCCESS] (state, data) {
      console.log('EXIST_REQUEST_HOLIDAY_NOTICE_SUCCESS')
      state.existRequestHolidayNotice = data.data.exist
      if (data.callback) {
        data.callback()
      }
    },
    [GET_SHIFT_NOTICE_COUNT_FAILURE] (state, data) {
      console.log('GET_SHIFT_NOTICE_COUNT_FAILURE')
    },
    [GET_SHIFT_NOTICE_COUNT_SUCCESS] (state, data) {
      console.log('GET_SHIFT_NOTICE_COUNT_SUCCESS')
      state.shiftNoticeCount = data.count
      state.shiftNotices = data.shift_notice
      if (data.callback) {
        data.callback()
      }
    },
    [GET_MAGAZINE_FAILURE] (state, data) {
      console.log('GET_MAGAZINE_FAILURE')
    },
    [GET_MAGAZINE_SUCCESS] (state, data) {
      console.log('GET_MAGAZINE_SUCCESS')
      state.magazines = data.data.magazines.data
      let minDate = data.data.min.toString()
      state.magazineMinYear = minDate.substr(0, 4)
      if (data.callback) {
        data.callback()
      }
    },
    [GO_KISOKU] (state, data) {
      var url = state.config.api_method + '://' + state.config.api_server + '/pdf/kisoku/kisoku.pdf'
      window.open(url, '_blank')
    },
    [GO_YESWECAN] (state, data) {
      var url = state.config.api_method + '://' + state.config.api_server + '/pdf/yeswecan/yeswecan.pdf'
      window.open(url, '_blank')
    },
    [EXIST_WILL_MUST_NOTICE_FAILURE] (state, data) {
      console.log('EXIST_WILL_MUST_NOTICE_FAILURE')
    },
    [EXIST_WILL_MUST_NOTICE_SUCCESS] (state, data) {
      console.log('EXIST_WILL_MUST_NOTICE_SUCCESS')
      state.existWillMustNotice = data.data.exist
      if (data.callback) {
        data.callback()
      }
    },
    [EXIST_PROPOSE_NOTICE_FAILURE] (state, data) {
      console.log('EXIST_PROPOSE_NOTICE_FAILURE')
    },
    [EXIST_PROPOSE_NOTICE_SUCCESS] (state, data) {
      console.log('EXIST_PROPOSE_NOTICE_SUCCESS')
      state.existProposeApprovedNotice = data.data.approved
      state.existProposeAdoptedNotice = data.data.adopted
      if (data.callback) {
        data.callback()
      }
    },
    [GET_TARGET_SERVICE_QUESTION_COUNT_FAILURE] (state, data) {
      console.log('GET_TARGET_SERVICE_QUESTION_COUNT_FAILURE')
    },
    [GET_TARGET_SERVICE_QUESTION_COUNT_SUCCESS] (state, data) {
      console.log('GET_TARGET_SERVICE_QUESTION_COUNT_SUCCESS')
      state.targetServiceQuestionCount = data.count
      state.ownServiceQuestion = data.own_service_question
      if (data.callback) {
        data.callback()
      }
    },
    [GET_NOANSWER_SERVICE_QUESTION_COUNT_FAILURE] (state, data) {
      console.log('GET_NOANSWER_SERVICE_QUESTION_COUNT_FAILURE')
    },
    [GET_NOANSWER_SERVICE_QUESTION_COUNT_SUCCESS] (state, data) {
      console.log('GET_NOANSWER_SERVICE_QUESTION_COUNT_SUCCESS')
      state.noanswerServiceQuestionCount = data.count
      if (data.callback) {
        data.callback()
      }
    },
    [EXIST_SAFETY_CONFIRMATION_FAILURE] (state, data) {
      console.log('EXIST_SAFETY_CONFIRMATION_FAILURE')
    },
    [EXIST_SAFETY_CONFIRMATION_SUCCESS] (state, data) {
      console.log('EXIST_SAFETY_CONFIRMATION_SUCCESS')
      console.log(data.data)
      state.isExistSafetyConfirmation = data.data.is_exist
      state.isTrainingSafetyConfirmation = data.data.is_training
      state.isSentSafetyConfirmation = data.data.is_sent
      state.isConfirmedSafetyConfirmation = data.data.is_confirmed
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js